import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ThemeSettings } from './theme/Theme';
import RTL from './layouts/full/shared/customizer/RTL';
import ScrollToTop from './components/shared/ScrollToTop';
import { CssBaseline, ThemeProvider } from '@mui/material';
import NotificationAlert from './components/shared/NotificationAlert';
import { AuthProvider } from './guards/jwt/JwtContext';
import { AlertProvider } from './context/AlertContext';
import SentryRouteTracker from './components/tracking/SentryRouteTracker';
import SentryActionTracker from './components/tracking/SentryActionTracker';
import SentryErrorBoundary from './components/SentryErrorBoundary';

/**
 * Router layout: tema, auth, Sentry izleme ve sayfa içeriği (Outlet).
 * Önceden App.jsx içinde useRoutes ile yapılan gösterim RouterProvider + Outlet ile devam eder.
 */
function AppShell() {
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);

  return (
    <AuthProvider>
      <AlertProvider>
        <SentryErrorBoundary>
          <ThemeProvider theme={theme}>
            <RTL direction={customizer.activeDir}>
              <CssBaseline />
              <NotificationAlert />
              <SentryRouteTracker />
              <SentryActionTracker />
              <ScrollToTop>
                <Outlet />
              </ScrollToTop>
            </RTL>
          </ThemeProvider>
        </SentryErrorBoundary>
      </AlertProvider>
    </AuthProvider>
  );
}

export default AppShell;
